export { default as AboutUsPage } from './AboutUsPage/AboutUsPage';
export { default as Milestones } from './Milestones/Milestones';
export { default as Awards } from './Awards/Awards';
export { default as TitleBlock } from './TitleBlock/TitleBlock';
export { default as ColorCards } from './ColorCards/ColorCards';
export { default as Vacancies } from './Vacancies/Vacancies';
